import CmsComponentButton from "@/helpers/editor/components/CmsComponentButton.js";
import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import {extractHtmlText} from "@vue-components/helpers/utils.js";

export default class CmsBlockTitle extends CmsBlock {
    static typeDef = {
        name: `Title|Titre`,
        type: `title`,
        category: `preset`,
        glyph: `fa-text`,
        isParent: false
    }

    get displayName() {
        if (this.item) {
            return tr(this.item.name);
        } else {
            return extractHtmlText(tr(this.title.text), 24);
        }
    }

    constructor(data, page) {
        super(data, page);

        this.title = new CmsComponentText(this.title);

        this.subtitle = new CmsComponentText(this.subtitle);

        this.description = new CmsComponentText(this.description);

        this.button = new CmsComponentButton(this.button);

        if (!data) {
            this.title.initText({}, `h2`);
            this.subtitle.initText({}, `h4`);
            this.description.initText({});

            this.button.active = false;
            this.button.initText({});
        }
    }
}
